// @ts-nocheck
import { useParams } from "react-router-dom"
import { useTopicData } from "@/lib/hooks/useTopicData"
import { TopicHeader } from "@/components/topics/TopicHeader"
import { TopicSidebar } from "@/components/topics/TopicSidebar"
import { FeedContainer } from "@/components/feed/FeedContainer"
import { FeedSkeleton } from "@/components/feed/FeedSkeleton"
import { useAuth } from "@/components/layout/AuthProvider"

export default function TopicDetailPage() {
  const { slug } = useParams<{ slug: string }>()
  const { supabaseUser } = useAuth()
  const { topic, loading } = useTopicData(slug || "")

  if (loading) return <FeedSkeleton />
  if (!topic) return <div className="container-narrow py-16 text-center text-text-muted">Topic not found</div>

  return (
    <div className="container-app py-4">
      <TopicHeader topic={topic} userId={supabaseUser?.id || null} />
      <div className="flex gap-6 mt-4">
        <div className="flex-1 min-w-0 max-w-[620px]">
          <FeedContainer userId={supabaseUser?.id || null} topicId={topic.id} subscribedTopics={[]} />
        </div>
        <div className="hidden xl:block w-[300px] flex-shrink-0">
          <TopicSidebar topic={topic} userId={supabaseUser?.id || null} />
        </div>
      </div>
    </div>
  )
}